module.exports = __webpack_public_path__ + "di-logo.jpg?3c705640f45004c5386e944c8408b410";